/* unplugin-vue-components disabled */import { render } from "./copy.vue?vue&type=template&id=bf6abdb6&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"

import "./copy.vue?vue&type=style&index=0&id=bf6abdb6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6abdb6"],['__file',"src/controls/copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf6abdb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf6abdb6', __exports__)) {
    api.reload('bf6abdb6', __exports__)
  }
  
  module.hot.accept("./copy.vue?vue&type=template&id=bf6abdb6&scoped=true", () => {
    api.rerender('bf6abdb6', render)
  })

}


export default __exports__